import styled from 'styled-components';
// import {device} from 'styled/device';

export const ShareBlock = styled.div`
  display: flex;
  flex-direction: column;

  .text {
    padding: 30px 0;
    font-size: 14px;
    color: #161643;
    flex-grow: 1;
  }

  .links {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    grid-gap: 15px;

    font-size: 15px;
    font-weight: 500;
  }
  
  .link-home {
    cursor: pointer;
    color: #161643;
  }

  .link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    grid-gap: 10px;
    cursor: pointer;
    color: #161643;

    &:hover {
      opacity: 0.8;
    }
`;

export const GuestsStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  grid-gap: 10px;
  color: #161643;
`;
